'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _botSessions = require('./bot-sessions.component');

var _botSessions2 = _interopRequireDefault(_botSessions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var botSessionsModule = _angular2.default.module('app.containers.bot-sessions', [_angularUiRouter2.default]).config(function ($stateProvider) {
  "ngInject";

  $stateProvider.state('botSessions', {
    url: '/bot-sessions',
    template: '<bot-sessions></bot-sessions>'
  });
}).component('botSessions', _botSessions2.default);

exports.default = botSessionsModule;


/** WEBPACK FOOTER **
 ** ./client/app/containers/bot-sessions/bot-sessions.js
 **/